import { FC } from 'react';
import DiscountPrice from './discount-price';
import {
  MergedPriceAndAvailabilityResponse,
  ProductDealerPriceAvailability,
  ReplacementParts
} from 'services/dealerPriceAvailability/types';
import { Conditional } from '@cat-ecom/pcc-components';
import { useTranslations } from 'next-intl';
import cx from 'classnames';

interface PriceProps {
  price:
    | MergedPriceAndAvailabilityResponse
    | ProductDealerPriceAvailability
    | ReplacementParts;
  currency: string;
  showDiscountSection?: boolean;
  isCoreDepositMobileDrawer?: boolean;
  isMobileView?: boolean;
}

const Price: FC<PriceProps> = ({
  price,
  currency,
  showDiscountSection = true,
  isCoreDepositMobileDrawer = false,
  isMobileView = false
}) => {
  const t = useTranslations();

  return (
    !!price?.totalPrice && (
      <>
        {price.enableAddToCart && (
          <p
            className={cx('m-0', {
              'ps-2': !isMobileView,
              'pt-1': isMobileView
            })}
          >
            <span className="cat-u-theme-typography-title-sm">
              {`${price?.totalPrice}`}
            </span>
            <span
              className={cx('px-1', {
                'cat-u-theme-typography-label-lg': !isMobileView,
                'fw-normal': isMobileView
              })}
            >
              {currency}
            </span>
          </p>
        )}
        <Conditional test={price?.unitPrice !== price.totalPrice}>
          {price?.discountedPrice ? (
            <p
              className={cx({
                'cat-u-theme-typography-body-sm': !isMobileView,
                'mb-0 cat-u-theme-typography-footnote': isMobileView
              })}
              style={{ color: 'var(--cat-color-neutral-60)' }}
            >
              {`${price?.discountedPrice}   ${t('ITEM_EA_ABB')}`}
            </p>
          ) : (
            <p
              className={cx({
                'cat-u-theme-typography-body-sm': !isMobileView,
                'mb-0 cat-u-theme-typography-footnote': isMobileView
              })}
              style={{ color: 'var(--cat-color-neutral-60)' }}
            >
              {`${price?.unitPrice}`} {t('ITEM_EA_ABB')}
            </p>
          )}
        </Conditional>
        <Conditional test={showDiscountSection}>
          <DiscountPrice
            price={price}
            isCoreDepositMobileDrawer={isCoreDepositMobileDrawer}
            isMobile
          />
        </Conditional>
      </>
    )
  );
};

export default Price;
